
const SkinConditionLabels: { [key: string]: string } = {
    "shine": "Txt585", // Oiliness
    "uneven_skin": "Txt593", // Uneven Skin Tone
    "redness": "Redness", // Score (placeholder for Redness) no
    "dark_circle": "Txt575", // Dark Circle
    "firmness": "Txt587", // Firmness
    "face_wrinkles": "Txt577", // Finelines & Wrinkles
    "hydration": "Txt581", // Hydration
    "skin_dullness": "Txt573", // Dullness
    "skin_health": "Txt574", // Score (placeholder for Skin Health)
    "crows_feet": "Txt579", // Crows Feet
    "texture": "Txt591", // Texture
    "oxygen": "Oxygen", // Score (placeholder for Oxygen) no
    "acne": "Acne", // Score (placeholder for Acne) no
    "eye_wrinkles": "Txt780", // Score (placeholder for Eye Wrinkles)
    "pigmentation": "pigmentation", // Score (placeholder for Pigmentation) no
    "dark_spots": "Txt583", // Dark Spots
    "smoothness": "Txt589" // Smoothness
};

// Helper function to get translation with special handling for eye_wrinkles
export const getConcernTranslation = (getTranslation: (key: string) => string, concern: string): string => {
    const translationKey = SkinConditionLabels[concern];
    if (!translationKey) return concern;
    
    const translation = getTranslation(translationKey);
    
    // Special handling for eye_wrinkles to remove the dash
    if (concern === "eye_wrinkles") {
        return translation.replace("-", " ");
    }
    
    return translation;
};

export default SkinConditionLabels;